module.exports = __webpack_public_path__ + "static/img/jchb1-6.a57f3f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-6.png
// module id = 764
// module chunks = 0